import React, { useState } from "react";
import { Button, Box, Grid, Typography, Popover } from "@material-ui/core";
import "../../assets/styles/FilterForm.css"; // Ensure this file contains your general styling

const DropdownFilter = ({ label, options, selectedOptions, onSelect }) => {
  const [anchorEl, setAnchorEl] = useState(null);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);
  const id = open ? "popover" : undefined;

  // Toggle selection of an option
  const handleOptionClick = (option) => {
    let updatedSelectedOptions;
    if (selectedOptions.includes(option)) {
      // If already selected, unselect it
      updatedSelectedOptions = selectedOptions.filter(
        (selected) => selected !== option
      );
    } else {
      // If not selected, add it to selectedOptions
      updatedSelectedOptions = [...selectedOptions, option];
    }

    onSelect(updatedSelectedOptions); // Pass the updated selected options to the parent
  };

  return (
    <div>
      <Button variant="contained" onClick={handleClick}>
        {label}
      </Button>
      <Popover
        id={id}
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "center",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "center",
        }}
      >
        <Box p={2}>
          <Grid container spacing={2}>
            {options.map((option, index) => (
              <Grid item xs={4} key={index}>
                <Button
                  fullWidth
                  variant={selectedOptions.includes(option) ? "contained" : "outlined"} // Change style based on selection
                  color={selectedOptions.includes(option) ? "primary" : "default"} // Color change on selection
                  onClick={() => handleOptionClick(option)} // Handle option selection
                >
                  {option}
                </Button>
              </Grid>
            ))}
          </Grid>
        </Box>
      </Popover>
    </div>
  );
};

export default DropdownFilter;
